"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
/**
 * Returns the max year that can be used to generate a quotation for a particular car.
 *
 * @param minMonthForNextYear - The min month that will be used to consider the max year to be next year
 */
function getMaxYear(minMonthForNextYear) {
    if (minMonthForNextYear === void 0) { minMonthForNextYear = 0; }
    var currentDate = Date.now();
    var currentMonthNumber = date_fns_1.getMonth(currentDate);
    if (currentMonthNumber < minMonthForNextYear) {
        return date_fns_1.getYear(currentDate);
    }
    return date_fns_1.getYear(date_fns_1.addYears(currentDate, 1));
}
exports.default = getMaxYear;
//# sourceMappingURL=getMaxYear.js.map